import {
  doGetQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import { CODIGO_RECEITA_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    CODIGO_RECEITA_ENDPOINT
  ]);
}

export async function fetchById(id) {
  return doGetQCXRequest([
    CODIGO_RECEITA_ENDPOINT,
    id
  ]);
}
